import { handleActions } from "redux-actions";

const initState = {
  isFetchingActivities: false,
  activities: null,
};

const reducer = handleActions(
  {
    REQUESTED_ACTIVITIES: (state) => ({
      ...state,
      isFetchingActivities: true,
    }),
    RECEIVED_ACTIVITIES: (state, action) => {
      const newState = {
        ...state,
      };
      newState.isFetchingActivities = false;
      newState.activities =
        action.payload.activities &&
        action.payload.activities.reduce((obj, item) => {
          if (item.result) {
            item.result = "Success";
          } else {
            item.result = "Fail";
          }
          obj.push(item);
          return obj;
        }, []);
      return newState;
    },
    REQUESTED_USER: (state, action) => {
      const newState = {
        ...state,
      };
      if (newState.activities) {
        newState.activities[action.payload.name] = {
          isFetchingActivity: true,
          name: action.payload.name,
        };
      }
      return newState;
    },
    RECEIVED_USER: (state, action) => {
      const newState = {
        ...state,
      };
      if (newState.activities) {
        newState.activities[action.payload.activity.name] = {
          ...action.payload.activity,
          isFetchingActivity: false,
        };
      }
      return newState;
    },
  },
  initState
);

export default reducer;
